import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IMessageSendEnmailListItem, MessageSendEnmailListItem } from "./messageSendEnmailListItem";
import { Base } from "ui/Scripts/source/framework/base";

export interface IMessageSendEnmailListItems extends ListItems<IMessageSendEnmailListItem> {
}

export class MessageSendEnmailListItems extends ListItems<MessageSendEnmailListItem> implements IMessageSendEnmailListItems {
    constructor();
    constructor(obj: IMessageSendEnmailListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, MessageSendEnmailListItem);
    }
}